import {Component} from "@angular/core";
import {MixpanelService} from "./misc/mixpanel/mixpanel.service";
import {NavigationEnd, Router} from "@angular/router";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
})
export class AppComponent {
    constructor(private mixpanelService: MixpanelService, private router: Router) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.mixpanelService.track(`Page Viewed - ${event.urlAfterRedirects}`, {page: event.urlAfterRedirects});
            }
        });
    }
}
